import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import styled, { createGlobalStyle } from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import store from './store';
import i18n from './i18n';
import ScreenManager from './ScreenManager';
import { MOBILE_BREAKPOINT_IN_PX } from './constants';
import fonts from './fonts';

// eslint-disable-next-line
const GlobalStyle = createGlobalStyle`
  ${fonts}
  body {
    margin: 0;
    padding: 0;
    font-family: Gotham Rounded SSm A, Arial, Georgia, Serif;
    font-weight: 350;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  select::-ms-expand {
    display: none; /* hide the default arrow in ie10 and ie11 */
  }
`;

const AppBorders = styled.div`
  /*
  border-top: 80px solid ${colors.primary.hslBlue};
  border-bottom: 80px solid ${colors.secondary.hslPurple};
  padding: 10px 0 10px 0;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    border-top-width: 15px;
    border-bottom-width: 15px;
    padding: 5px 0 5px 0;
  }
  */
`;

const AppWrapper = styled.div`
  background-color: ${colors.background.hslWhite};
  margin: 0;
  padding: 0;
`;

const App = () => (
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <GlobalStyle />
      <AppBorders>
        <AppWrapper>
          <ScreenManager />
        </AppWrapper>
      </AppBorders>
    </I18nextProvider>
  </Provider>
);

export default App;
